import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import type { AdminEnvelope } from '@/client/types/admin/users-orgs';
import type {
  WaitlistListParams,
  WaitlistListResponse,
} from '@/client/types/admin/marketing';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export const adminMarketingKeys = {
  all: ['admin', 'marketing'] as const,
  list: (params: WaitlistListParams) =>
    [...adminMarketingKeys.all, 'list', params] as const,
};

/**
 * `GET /api/admin/marketing` — captured marketing/waitlist leads.
 * Supports page/page_size, sort_by/sort_order, search, campaign_type, interest.
 */
export const useWaitlistQuery = (params: WaitlistListParams = {}) => {
  const queryFn = useGetQueryFn<AdminEnvelope<WaitlistListResponse>>({
    defaultErrorMessage: 'An unexpected error occurred while fetching the waitlist',
    endpoint: '/api/admin/marketing',
  });

  return useQuery({
    queryKey: adminMarketingKeys.list(params),
    queryFn: () => queryFn({ ...params }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
    select: (response) => response?.data,
  });
};
